import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { FuturePurchaseFormValues } from "src/models/FuturePurchase.model";
import FuturePurchase from "../Layouts/FuturePurchaseForm";
import { useAddFuturePurchaseMutation } from "src/services/FuturePurchaseService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddFuturePurchaseWrapper = ({ onClose }: Props) => {
  // Form Initial Value
  const initialValues: FuturePurchaseFormValues = {
    name: "",
    mobile: "",
    purchaseDate: "",
    subjects:[],
    faculties:[]
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter Future Purchaser name"),
    mobile: string()
      .required("Please enter Future Purchaser mobile")
      .min(10)
      .max(10),
    purchaseDate: string().required(
      "Please enter Future Purchaser purchase date"
    ),
  });

  const [addFuturePurchase] = useAddFuturePurchaseMutation();

  // Handle Submit
  const handleSubmit = (
    values: FuturePurchaseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<FuturePurchaseFormValues>
  ) => {
    const fomattedValues={
      name:values.name,
      mobile:values.mobile,
      purchaseDate:values.purchaseDate,
      subjects:values.subjects.map((item)=>item.value
      ),
      faculties:values.faculties.map((item)=>item.value)
    }
    addFuturePurchase(fomattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <FuturePurchase
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddFuturePurchaseWrapper;
